import './SecurityVerification.scss';

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendTextToClipBoard } from 'utilities/clipBoardHelper';
import { isCountrySpain } from 'utilities/multiLanguageHelper';
import Storage from 'utilities/storage';
import { checkConditionAndExecuteCallback } from 'utilities/toggling';
import { doTagHandleCancel, doTagHandleContinue, doTagHandleCopyIban, doTagSecurityVerification } from './tagging';
import { changeUserStatusCall, ibanTransferOTPCall } from 'actions/ibanActions';
import modalCancelActions from 'actions/modalCancelActions';
import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';
import stepsActions from 'actions/stepsActions';
import NumberOne from 'assets/icons/number-one.svg';
import NumberTwo from 'assets/icons/number-two.svg';
import { CopyIbanButton } from 'components/copyIbanButton/CopyIbanButton';
import Headline from 'components/headline';
import { HeadlineSubtitle } from 'components/headline/HeadlineSubtitle';
import { HeadlineTitle } from 'components/headline/HeadlineTitle';
import { Step } from 'components/newAccountSteps/profileSteps/securityVerification/Step';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { IBAN_TRANSFER_OTP_SEND_OTP } from 'constants/identityMethod';
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';
import { PENDING_OTP, TRANSFER_OTP } from 'constants/statusProcess';
import { ROBO, TRADITIONAL } from 'constants/userProfile';
import { formatText } from 'core/i18n';
import { goToErrorsView, setPageName } from 'actions/errorViewNavigation';

const STANDBY_INDEX_TRADITIONAL = 5;
const STANDBY_INDEX_DEPOSIT = 6;
const STANDBY_INDEX_ROBO = 7;

const SecurityVerificationComponent = ({
    ibanTransferOTPCall,
    showPreLoader,
    hidePreLoader,
    userProfile,
    immStepsState,
    stepsActions,
    modalCancelActions,
    changeUserStatusCall,
    goToErrorsView,
    setPageName,
}) => {
    const [ibanTransferData, setIbanTransferData] = useState({});

    const getTransferOtpData = async () => {
        const accessToken = Storage.cookies.get('accessToken');

        const transferOtpData = await ibanTransferOTPCall(accessToken, 'GET');
        setIbanTransferData(transferOtpData);
    };

    const handleStatusUserResponse = ({ status }) => {
        const accessToken = Storage.cookies.get('accessToken');

        checkConditionAndExecuteCallback(status === TRANSFER_OTP, async () => {
            try {
                const sendOtpCall = await ibanTransferOTPCall(accessToken, 'POST', IBAN_TRANSFER_OTP_SEND_OTP);
                if (sendOtpCall.status === 'OK') await getTransferOtpData();
            } catch (e) {
                goToErrorsView({
                    errorMessage: 'messagesScreen-transferErrorContent',
                    errorContent: 'messagesScreen-transferErrorContent',
                });
            } finally {
                await hidePreLoader();
            }
        });

        checkConditionAndExecuteCallback(status === PENDING_OTP, async () => {
            await getTransferOtpData();
            await hidePreLoader();
        });
    };

    useEffect(() => {
        showPreLoader();

        const accessToken = Storage.cookies.get('accessToken');
        changeUserStatusCall(accessToken, 'RETURN_STATUS').then(handleStatusUserResponse);

        const welcomeCard = immStepsState.get('welcomeCard');
        !welcomeCard && setPageName(doTagSecurityVerification(userProfile));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNextStepIndex = ({ investmentType, onboardingType }) => {
        const isRobo = investmentType === ROBO;
        const isDeposit = investmentType === TRADITIONAL && onboardingType === ONB_BANK_DEPOSIT_OPEN;

        if (userProfile.isJointHolder) return STANDBY_INDEX_TRADITIONAL;
        if (isDeposit) return STANDBY_INDEX_DEPOSIT;
        if (isRobo) return STANDBY_INDEX_ROBO;

        return STANDBY_INDEX_TRADITIONAL;
    };

    const handleContinue = () => {
        doTagHandleContinue();
        const currentStep = immStepsState.get('currentStep');
        const nextStepIndex = getNextStepIndex(userProfile);

        stepsActions.finalizeStep({ index: currentStep, finished: true });
        stepsActions.enableFinishedAndNextStep();
        stepsActions.changeCurrentStep({
            index: nextStepIndex,
        });
    };

    const handleCancel = () => {
        doTagHandleCancel();
        modalCancelActions.showModalCancel();
    };

    const handleCopyIban = () => {
        doTagHandleCopyIban();
        sendTextToClipBoard(userProfile.iban);
    };

    const headlineIcon = isCountrySpain() ? 'lock' : 'transfer';
    const identificacionTitleText = formatText(
        isCountrySpain() ? 'StepsTitles-transferOtpValidation' : 'StepsTitles-doTransfer'
    );
    const transferOTPStepsTitleText = isCountrySpain()
        ? formatText('identityTransfer-titleTransfer', [ibanTransferData.entityName, ibanTransferData.iban])
        : formatText('identityTransfer-titleTransferFromYourBank');

    const stepOneText = isCountrySpain()
        ? formatText('identityTransfer-transferText2', [ibanTransferData.entityName])
        : formatText('identityTransfer-transferText4');

    return (
        <>
            <WelcomeCard />
            <Headline icon={headlineIcon} className={'prospects-gutter'}>
                <HeadlineTitle id="identificacionTitle">{identificacionTitleText}</HeadlineTitle>
                {!isCountrySpain() && (
                    <HeadlineSubtitle>{formatText('StepsTitles-doTransferSubtitle')}</HeadlineSubtitle>
                )}
            </Headline>
            <div className={'transfer-otp-steps'}>
                <div className="transfer-otp-steps__title-container">
                    <p className={'title'}>{transferOTPStepsTitleText}</p>
                    <p className={'subtitle'}>{formatText('identityTransfer-transferText1')}</p>
                </div>
                <div className="transfer-otp-steps__steps-container">
                    <Step icon={NumberOne} stepNumber={1}>
                        <p>{stepOneText}</p>
                    </Step>
                    <Step icon={NumberTwo} stepNumber={2}>
                        <p>{formatText('identityTransfer-transferText3')}</p>
                        <div className="transfer-otp-steps__steps-container-iban">
                            <p className={'iban-text'}>{userProfile.iban}</p>
                            <CopyIbanButton handleCopyIban={handleCopyIban} />
                        </div>
                    </Step>
                </div>
            </div>

            <RoadmapNavigation
                stepFooter
                buttonDisabled={false}
                buttonContinueAction={handleContinue}
                buttonCancelAction={handleCancel}
                buttonContinueText={formatText('button-continue')}
                buttonPrevHidden={true}
            />
        </>
    );
};

export const SecurityVerification = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
    }),
    dispatch => ({
        hidePreLoader: bindActionCreators(hidePreLoader, dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
        ibanTransferOTPCall: bindActionCreators(ibanTransferOTPCall, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        changeUserStatusCall: bindActionCreators(changeUserStatusCall, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        setPageName: bindActionCreators(setPageName, dispatch),
    })
)(SecurityVerificationComponent);
